<template>
  <el-container>
    <el-header height="96px">
      <nav class="nav">
        <Logo />
        <Menus />
      </nav>
    </el-header>
    <el-main style="padding: 0;min-height: calc(100vh - 326px);">
      <Content></Content>
    </el-main>
    <el-footer style="height: auto; padding: 0">
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import Logo from './Logo.vue'
import Menus from './Menus.vue'
import Content from './Content.vue'
import Footer from './Footer.vue'

export default {
  components: { Logo, Menus, Content, Footer },
  data() {
    return {
      input:''
    }
  }
}
</script>

<style lang="less" scoped>
header {
  width: 1300px;
  height: 96px;
  padding: 0 40px;
  margin: 0 auto; 

  .nav {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}
</style>
